import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import PlayCircleIcon from 'components/material-symbol/icons/PlayCircle'
import { PGA_COACH_NAVY } from 'lib/styles/pga-coach-pill-colors'

// A navy tile with a play icon. A golfer's or coach's video thumbnail, when
// there is one, fills the tile untinted; the play icon gets a small dark round
// backdrop so it stays legible on any image.
const useStyles = makeStyles({
  root: {
    position: 'relative',
    width: 76,
    height: 46,
    borderRadius: 10,
    overflow: 'hidden',
    backgroundColor: PGA_COACH_NAVY,
    color: '#FFFFFF',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  // Fills its container at 16:9, for galleries.
  large: {
    display: 'flex',
    width: '100%',
    height: 'auto',
    aspectRatio: '16 / 9',
    borderRadius: 8,
    '& $icon': { fontSize: 48 },
  },
  image: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  playBadge: {
    position: 'relative',
    display: 'inline-flex',
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  icon: {
    position: 'relative',
    fontSize: 24,
  },
})

const VideoThumbnail = ({ src, alt, large = false }) => {
  const classes = useStyles()
  return (
    <Box className={`${classes.root} ${large ? classes.large : ''}`}>
      {src ? <img className={classes.image} src={src} alt={alt} /> : null}
      <span className={src ? classes.playBadge : undefined}>
        <PlayCircleIcon
          className={classes.icon}
          aria-label={src || !alt ? undefined : alt}
        />
      </span>
    </Box>
  )
}

VideoThumbnail.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  large: PropTypes.bool,
}

export default VideoThumbnail
